export const SEARCH_CLEAR_RESULTS = "SEARCH_CLEAR_RESULTS";
export const SEARCH_CLIENTS = "SEARCH_CLIENTS";
export const SEARCH_CLIENTS_SUCCESS = "SEARCH_CLIENTS_SUCCESS";
export const SEARCH_MEMBERS = "SEARCH_MEMBERS";
export const SEARCH_MEMBERS_SUCCESS = "SEARCH_MEMBERS_SUCCESS";
export const SEARCH_UPDATE_SEARCH = "SEARCH_UPDATE_SEARCH";
export const SEARCH_FORCE_OPEN = "SEARCH_FORCE_OPEN";



// WEBPACK FOOTER //
// ./src/components/dashboard/search/searchActionTypes.js